<script lang="ts">
    import { createEventDispatcher, onMount } from 'svelte/internal'
    const dispatch = createEventDispatcher()
    import { faAngleLeft, faEdit, faPlusCircle, faSave, faTrashAlt } from '@fortawesome/free-solid-svg-icons'
    import { Gateway, GatewaysBrands } from '../../../modules/paymentsApi/gateways/gateway.entity'
    import type { CreateGatewayDto } from '../../../modules/paymentsApi/gateways/dto/create-gateway.dto'
    import type { UpdateGatewayDto } from '../../../modules/paymentsApi/gateways/dto/update-gateway.dto'
    import Content from '../../_common/content.svelte'
    import LoadSpinner from '../../_common/load-spinner.svelte'
    import { GatewaysList } from '../../../modules/paymentsApi/gateways/gateways.enum'
    import { GridButton, GridClass, GridCol, GridColTypeEnum, GridLine } from '../../_common/z/zgrid'
    import Zgrid from '../../_common/z/zgrid.svelte'
    import Zframe from '../../_common/z/zframe.svelte'
    import Zact from '../../_common/z/zact.svelte'
    import Zbutton from '../../_common/z/zbutton.svelte'
    import Zinput from '../../_common/z/zinput.svelte'
    import ZContainer from '../../_common/z/z-container.svelte'
    import { PurchaseType } from '../../../modules/paymentsApi/purchases/purchase.enum'
    // ##############################################################################################################

    export let form: boolean = false
    export let gatewayId: string = null
    let entity: Gateway = new Gateway()

    let billContinuous = true
    let billFixed = true
    let billFull = false

    let selectedBrands = []
    let availableBrands = []
    for (const [key, value] of Object.entries(GatewaysBrands)) {
        availableBrands.push({
            label: value,
            value: key,
        })
    }

    // opção vazia explícita: sem ela o select fica sem seleção visível enquanto o valor está vazio
    const gatewayOptions = [{ value: '', label: '' }, ...Object.keys(GatewaysList).map((key) => ({ value: key, label: key }))]

    async function editEntity(id: string) {
        try {
            show = true
            entity = new Gateway()
            entity = await window.api.payments.gateways.getOne(id)
            billContinuous = entity.billIntegration.some((el) => el === PurchaseType.recurring_continuous)
            billFixed = entity.billIntegration.some((el) => el === PurchaseType.recurring_fixed)
            billFull = entity.billIntegration.some((el) => el === PurchaseType.full_charge)
            console.log('gateway', entity)
            selectedBrands = []
            for (const item of entity.brands) {
                selectedBrands.push(item.brand)
            }
            step = 2
        } catch (error) {
            evaluateError(error)
        } finally {
            show = false
        }
    }

    function newEntity() {
        entity = new Gateway()
        step = 2
    }

    async function createEntity() {
        try {
            show = true
            let billIntegration: string[] = []
            if (billContinuous) billIntegration.push(PurchaseType.recurring_continuous)
            if (billFixed) billIntegration.push(PurchaseType.recurring_fixed)
            if (billFull) billIntegration.push(PurchaseType.full_charge)
            let dto: CreateGatewayDto = {
                billIntegration,
                gateway: entity.gateway,
                label: entity.label,
                appId: entity.appId,
                secret: entity.secret,
                token: entity.token,
                issuerAddress: entity.issuerAddress,
                issuerBusinessName: entity.issuerBusinessName,
                issuerDocument: entity.issuerDocument,
                issuerEmail: entity.issuerEmail,
                issuerLegalName: entity.issuerLegalName,
                issuerPhone: entity.issuerPhone,
                brands: [],
            }
            for (const item of selectedBrands) {
                dto.brands.push({
                    brand: item,
                    installments: 12,
                })
            }
            entity = await window.api.payments.gateways.create(dto)
            if (form) {
                sendClose()
                return
            }
            await loadEntities()
        } catch (error) {
            evaluateError(error)
        } finally {
            show = false
        }
    }

    function sendClose() {
        dispatch('close')
    }

    async function updateEntity() {
        try {
            show = true
            let billIntegration: string[] = []
            if (billContinuous) billIntegration.push(PurchaseType.recurring_continuous)
            if (billFixed) billIntegration.push(PurchaseType.recurring_fixed)
            if (billFull) billIntegration.push(PurchaseType.full_charge)
            let dto: UpdateGatewayDto = {
                billIntegration,
                label: entity.label,
                appId: entity.appId,
                secret: entity.secret,
                token: entity.token,
                issuerAddress: entity.issuerAddress,
                issuerBusinessName: entity.issuerBusinessName,
                issuerDocument: entity.issuerDocument,
                issuerEmail: entity.issuerEmail,
                issuerLegalName: entity.issuerLegalName,
                issuerPhone: entity.issuerPhone,
                brands: [],
            }
            for (const item of selectedBrands) {
                dto.brands.push({
                    brand: item,
                    installments: 12,
                })
            }
            await window.api.payments.gateways.update(entity.gatewayId, dto)
            if (form) {
                sendClose()
                return
            }
            await loadEntities()
        } catch (error) {
            evaluateError(error)
        } finally {
            show = false
        }
    }

    async function saveEntity() {
        if (entity.gatewayId) {
            updateEntity()
        } else {
            createEntity()
        }
    }

    async function loadEntities() {
        try {
            show = true
            step = 1
            entities = await window.api.payments.gateways.getAll()
            loadGrid()
        } catch (error) {
            evaluateError(error)
        } finally {
            show = false
        }
    }

    async function removeEntity() {
        if (!confirm('Deseja mesmo excluir este registro?')) {
            return
        }
        try {
            show = true
            await window.api.payments.gateways.remove(entity.gatewayId)
            await loadEntities()
        } catch (error) {
            evaluateError(error)
        } finally {
            show = false
        }
    }

    function evaluateError(error) {
        window.error(error)
    }

    function showEntities() {
        step = 1
    }

    let show = false
    let step = 1
    let entities = []

    onMount(async () => {
        await loadEntities()
        if (form) {
            if (gatewayId) {
                await editEntity(gatewayId)
            } else {
                newEntity()
            }
        }
    })

    let grid: GridClass = new GridClass()
    function loadGrid() {
        // grid
        grid = new GridClass()
        // grid head
        grid.title = 'Gateways'
        grid.subtitle = ''
        grid.showActs = false
        grid.cols.push(new GridCol({ content: 'Gateway', type: GridColTypeEnum.string }))
        grid.cols.push(new GridCol({ content: 'Nome', type: GridColTypeEnum.string }))
        if (window.store.token.permissions.pay.gateways.write) {
            grid.cols.push(new GridCol({ content: '', type: GridColTypeEnum.button }))
        }
        // grid lines
        for (const item of entities) {
            const btnEdit = new GridButton({
                callback: () => editEntity(item.gatewayId),
                icon: faEdit,
                label: 'Editar',
            })
            let line: GridLine = new GridLine()
            line.slots.push({ content: item.gateway })
            line.slots.push({ content: item.label })
            if (window.store.token.permissions.pay.gateways.write) {
                line.slots.push({ content: [btnEdit] })
            }

            grid.lines.push(line)
        }
    }
</script>

{#if step === 1}
    <Content footer={true}>
        <Zact>
            <div class="spacer" />
            {#if window.store.token.permissions.pay.gateways.write}
                <Zbutton color="primary" icon={faPlusCircle} label="Novo gateway" mobileHideLabel={true} on:click={newEntity} />
            {/if}
        </Zact>
        <Zgrid class="h-space" {grid} />
        <LoadSpinner {show} />
    </Content>
{/if}
{#if step === 2}
    <Content footer={true}>
        <Zact>
            {#if !form}
                <Zbutton color="secondary" icon={faAngleLeft} label="Voltar" on:click={showEntities} />
            {/if}
            <div class="spacer" />
            {#if window.store.token.permissions.pay.gateways.write}
                {#if !!entity.gatewayId}
                    <Zbutton color="red" icon={faTrashAlt} label="Excluir" disabled={show} on:click={removeEntity} />
                {/if}
                <Zbutton color="primary" icon={faSave} label="Salvar" loading={show} disabled={show} on:click={saveEntity} />
            {/if}
        </Zact>
        <Zframe class="h-space" title="Dados do gateway de pagamentos">
            <ZContainer gapRow="8px" gapCol="8px">
                <Zinput
                    size={6}
                    sizeM={12}
                    label="Gateway"
                    type="select"
                    options={gatewayOptions}
                    disabled={!!entity.gatewayId}
                    bind:value={entity.gateway}
                />
                <Zinput size={6} sizeM={12} label="Nome para o gateway" type="text" bind:value={entity.label} />
                <Zinput size={6} sizeM={12} label="AppId / MerchantId / Key" type="text" bind:value={entity.appId} />
                <Zinput size={6} sizeM={12} label="Secret / MerchantKey / Access Token" type="text" bind:value={entity.secret} />
                <Zinput size={12} label="Bandeiras aceitas" type="inlineselect_2" multi={true} options={availableBrands} bind:value={selectedBrands} />
            </ZContainer>
        </Zframe>
        <Zframe class="h-space" title="Dados da empresa a serem exibidos ao pagador">
            <ZContainer gapRow="8px" gapCol="8px">
                <Zinput size={6} sizeM={12} label="Razão Social" type="text" bind:value={entity.issuerLegalName} />
                <Zinput size={6} sizeM={12} label="Nome Fantasia" type="text" bind:value={entity.issuerBusinessName} />
                <Zinput size={6} sizeM={12} label="CNPJ / CPF" type="text" bind:value={entity.issuerDocument} />
                <Zinput size={6} sizeM={12} label="Endereço completo" type="text" bind:value={entity.issuerAddress} />
                <Zinput size={6} sizeM={12} label="Telefone do financeiro" type="tel" bind:value={entity.issuerPhone} />
                <Zinput size={6} sizeM={12} label="E-Mail do financeiro" type="text" bind:value={entity.issuerEmail} />
            </ZContainer>
        </Zframe>
        <Zframe class="h-space" title="Integração com o Contas a Receber" headline="Escolha quais tipos de cobrança deverão ser lançadas no 'Contas a Receber'">
            <ZContainer gapRow="8px" gapCol="8px">
                <Zinput size={12} type="toggle" label="Cobrança recorrente com parcelas fixas predeterminadas" bind:value={billFixed} />
                <Zinput size={12} type="toggle" label="Cobrança recorrente com parcelas contínuas (assinatura)" bind:value={billContinuous} />
                <Zinput size={12} type="toggle" label="Cobrança convencional no cartão" bind:value={billFull} />
            </ZContainer>
        </Zframe>
        <LoadSpinner {show} />
    </Content>
{/if}
